var map = {
	"./afb-color.svg": 616,
	"./alb-color.svg": 617,
	"./all.svg": 618,
	"./amb-color.svg": 619,
	"./arg.svg": 620,
	"./aus.svg": 621,
	"./bank-icon.svg": 622,
	"./bankdemo-color.svg": 623,
	"./bel.svg": 624,
	"./bimb-color.svg": 625,
	"./bkr-color.svg": 626,
	"./bpay-color.svg": 627,
	"./bra.svg": 628,
	"./bsn-color.svg": 629,
	"./can.svg": 630,
	"./checked-green.png": 631,
	"./checked-white.png": 632,
	"./cimb-color.svg": 633,
	"./cimb-icon.svg": 634,
	"./citi-color.svg": 635,
	"./cmr.svg": 636,
	"./crc.svg": 637,
	"./cro.svg": 638,
	"./den.svg": 639,
	"./ecu.svg": 640,
	"./eng.svg": 641,
	"./esp.svg": 642,
	"./fav-blue.svg": 643,
	"./fav-gray.png": 644,
	"./fav-gray.svg": 645,
	"./fav-icon-active.png": 646,
	"./fav-icon.png": 647,
	"./fav-red.png": 648,
	"./fra.svg": 649,
	"./game-icon.svg": 650,
	"./games-active-m.svg": 651,
	"./ger.svg": 652,
	"./gha.svg": 653,
	"./gxbank-color.svg": 654,
	"./hlb-color.svg": 655,
	"./hlb-icon.svg": 656,
	"./hsbc-color.svg": 657,
	"./irn.svg": 658,
	"./jpn.svg": 659,
	"./kor.svg": 660,
	"./ksa.svg": 661,
	"./kwh-color.svg": 662,
	"./latest-icon-active.png": 663,
	"./latest-icon.png": 664,
	"./lc-active-m.svg": 665,
	"./lc-icon.svg": 666,
	"./lottery-active-m.svg": 667,
	"./lottery-icon.svg": 668,
	"./lottery-m.svg": 669,
	"./love.svg": 670,
	"./mar.svg": 671,
	"./mbb-color.svg": 672,
	"./mex.svg": 673,
	"./ned.svg": 674,
	"./ocbc-color.svg": 675,
	"./ocbc-icon.svg": 676,
	"./p2p-active-m.svg": 677,
	"./p2p-icon.svg": 678,
	"./p2p-m.svg": 679,
	"./pbb-color.svg": 680,
	"./pol.svg": 681,
	"./por.svg": 682,
	"./price-high.svg": 683,
	"./price-low.svg": 684,
	"./qat.svg": 685,
	"./rhb-color.svg": 686,
	"./rhb-icon.svg": 687,
	"./scb-color.svg": 688,
	"./sen.svg": 689,
	"./slot-active-m.svg": 690,
	"./slot-icon.svg": 691,
	"./sport-active-m.svg": 692,
	"./sports-icon.svg": 693,
	"./srb.svg": 694,
	"./star.svg": 695,
	"./sui.svg": 696,
	"./tng-color.svg": 697,
	"./trx-icon.svg": 698,
	"./trx.svg": 699,
	"./tun.svg": 700,
	"./uob-color.svg": 701,
	"./uru.svg": 702,
	"./usa.svg": 703,
	"./usdc.svg": 704,
	"./usdt.svg": 705,
	"./ustd-icon.svg": 706,
	"./wal.svg": 707,
	"./x33-logo-b.svg": 708,
	"./x33-square-icon.svg": 709
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 119;